<template>
    <div class="w-full p-2 flex flex-col justify-between items-center rounded-md bg-black text-white">
        <span class="text-2xl font-bold py-1.5">{{ value }}</span>

        <span class="text-sm text-center">{{ label }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            }
        }
    }
</script>